<div class="associated-segs-btns-div">
  <h6 class="small-light-text mb-2">{{ 'Associated SEG\'s' | translate }}</h6>
  @if (exposureAllSEGs && exposureAllSEGs.length) {
    <div class="btns-div">
      @for (seg of exposureAllSEGs; track trackById($index, seg)) {
        <a class="round-btns extra-light-purple-bg purple-text">{{seg.name}}</a>
      }
    </div>
  }
  @if (!loadingAllSEGs && !(exposureAllSEGs && exposureAllSEGs.length)) {
    <div class="no-seg-associated">
      {{errorMessage}}
    </div>
  }
</div>